import "./offer-card.scss";

const OfferCard = ({ offerAmt, minOrderAmt, discountType, offerSelected, onClick, applyButton, onApply }) => {
  const offerImage = (type) => {
    switch (type) {
      case "percentage":
        return "%";
      case "flat":
        return "Flat";
      default:
        return null;
    }
  };

  const offerImageValue = offerImage(discountType);
  const cardClassName = offerSelected ? "offer-card not-selected":"offer-card selected";

  return (
    <div className={cardClassName}>
      {/* {discountType === "flat" && <p className="discount-type">Flat</p>} */}
      <div className="offer-text-section">
        <div className="header" onClick={onClick}>
          {offerAmt}
          {offerImageValue}
          {" OFF"}
        </div>
        <div className="sub-header" onClick={onClick}>
          {/* {"MOV "} */}
          {"Min. Amount "}
        </div>
        <div className="min-amount" onClick={onClick}>
          <span>&#8377;</span>
          {minOrderAmt}
        </div>
        {applyButton &&
          <div className="apply-button" onClick={onApply}>
            {offerSelected?"REMOVE":"APPLY"}
          </div>
        }
      </div>
    </div>
  );
};

export default OfferCard;
